export default {
  root: {
    '&.Mui-focusVisible': {
      outlineStyle: 'solid',
      outlineWidth: '2px',
    },
  },
};
